import { atom } from 'jotai';
import type { CreateCommentType, TextAtoms } from '@/types';

export const createCommentAtom = atom<CreateCommentType | null>(null);

export const commentableTextAtomsAtom = atom<Record<string, TextAtoms>>({});

export interface CommentsDrawerState {
    focusComment: number | null;
    show: boolean;
    showTopInput: boolean;
    filter?: string;
    filterName?: string;
    textAtomContent: string;
    selectionIndex: number;
    commentableModel: string | null;
    commentableId: number | null;
    position?: string;
    group?: string;
    isCommentBlockFocusClick: boolean;
}

export const commentsDrawerAtom = atom<CommentsDrawerState>({
    show: false,
    showTopInput: false,
    focusComment: null,
    filter: undefined,
    textAtomContent: '',
    selectionIndex: -1,
    commentableId: null,
    commentableModel: null,
    position: undefined,
    group: undefined,
    isCommentBlockFocusClick: false,
});
